import { TRESPONSE_FACTORY_ALLOCATION_LISTING } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellType, TTableOptions, TTextCell } from '../../table.type';

export const FACTORY_ALLOCATION_TABLE_MODEL = {
  createModel: (
    headerInfo: TRESPONSE_FACTORY_ALLOCATION_LISTING['header_info'],
    rowInfo: TRESPONSE_FACTORY_ALLOCATION_LISTING['orders'],
  ) => {
    if (rowInfo.length === 0) return FACTORY_ALLOCATION_TABLE_MODEL.createIdentityModel();

    return ModifiersZTableModel.createTableModel(
      rowInfo,
      {
        padding: 24,
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
          stickyType: 'LEFT',
        },
        headerConfig: createHeaderRow(headerInfo),
      },
      (item) => {
        return {
          type: 'ROW' as const,
          rowItem: item,
          cells: getTableRowCells(headerInfo, item),
        };
      },
    );
  },

  createIdentityModel: () => {
    return ModifiersZTableModel.createTableModel(
      [] as TRESPONSE_FACTORY_ALLOCATION_LISTING['orders'],
      {
        padding: 8,
        headerConfig: [],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [],
        };
      },
    );
  },
};

const createHeaderRow = (
  headerInfo: TRESPONSE_FACTORY_ALLOCATION_LISTING['header_info'],
): TTableOptions['headerConfig'] => {
  return headerInfo.map(
    (hInfo): TTextCell => ({
      type: 'TEXT_CELL',
      text: hInfo.display_name,
    }),
  );
};

const getTableRowCells = (
  headerInfo: TRESPONSE_FACTORY_ALLOCATION_LISTING['header_info'],
  rowItem: TRESPONSE_FACTORY_ALLOCATION_LISTING['orders'][number],
): TTableCellType[] => {
  return headerInfo.map((hInfo) => ({
    type: 'TEXT_CELL',
    text: rowItem.order[hInfo.key],
  }));
};
